import { render, staticRenderFns } from "./CashbackCpfPointsLimit.vue?vue&type=template&id=3e51ea18"
import script from "./CashbackCpfPointsLimit.vue?vue&type=script&lang=js"
export * from "./CashbackCpfPointsLimit.vue?vue&type=script&lang=js"
import style0 from "./CashbackCpfPointsLimit.vue?vue&type=style&index=0&id=3e51ea18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports